import { types } from 'mobx-state-tree';

import { PaymentFrequencyEnum } from '../definitions/PaymentFrequency';
import { RateTypeEnum } from '../definitions/RateType';
import { IsoDate } from '../../../common/v1';


const Mortgage = types.model('Mortgage', {
    // prospective mortgage only
    amortization: types.maybe(types.number), // in months
    type: types.maybe(RateTypeEnum),
    term: types.maybe(types.number),

    // purchase
    purchasePrice: types.maybe(types.number),
    downPayment: types.maybe(types.number),
    insurancePremium: types.maybe(types.number),

    // renewal
    isInsured: types.maybe(types.boolean),

    // refi
    additionalFundsRequired: types.maybe(types.number),


    // shared
    mortgageAmount: types.maybe(types.number),
    payment: types.maybe(types.number),
    paymentFrequencyType: types.maybe(PaymentFrequencyEnum),


    // existing mortgage only
    currentMortgageBalance: types.maybe(types.number),
    renewalDate: types.maybe(IsoDate),
    interestRate: types.maybe(types.number),
    lenderType: types.maybe(types.string), // Comes from API
});

export default Mortgage;
